"use strict";
(globalThis["webpackChunkweb"] = globalThis["webpackChunkweb"] || []).push([[2747],{

/***/ 96431:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DB: () => (/* binding */ legacyEnvironmentNameMatchesType),
/* harmony export */   Hk: () => (/* binding */ legacyEnvironmentNameToEnvironmentSlug),
/* harmony export */   KG: () => (/* binding */ ProductionEnvironmentName),
/* harmony export */   Qj: () => (/* binding */ EnvironmentType),
/* harmony export */   Sk: () => (/* binding */ EnvironmentNameMSTType),
/* harmony export */   a2: () => (/* binding */ EnvironmentStatus),
/* harmony export */   am: () => (/* binding */ EnvironmentTypeMSTType),
/* harmony export */   g7: () => (/* binding */ DevelopmentEnvironmentSlug),
/* harmony export */   gq: () => (/* binding */ EnvironmentNames),
/* harmony export */   qT: () => (/* binding */ legacyEnvironmentNameToEnvironmentType),
/* harmony export */   wv: () => (/* binding */ isEnvironmentName),
/* harmony export */   x0: () => (/* binding */ ProductionEnvironmentSlug),
/* harmony export */   y2: () => (/* binding */ DevelopmentEnvironmentName)
/* harmony export */ });
/* unused harmony exports environmentTypeToLegacyEnvironmentName, environmentTypeToNodeEnv */
/* harmony import */ var _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49923);
/* harmony import */ var _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__);

var EnvironmentStatus;
(function(EnvironmentStatus) {
    EnvironmentStatus["PENDING"] = "pending";
    EnvironmentStatus["ACTIVE"] = "active";
    EnvironmentStatus["PAUSED"] = "paused";
    EnvironmentStatus["FATAL_ERROR"] = "fatal_error";
})(EnvironmentStatus || (EnvironmentStatus = {}));
var EnvironmentType;
(function(EnvironmentType) {
    EnvironmentType["Test"] = "test";
    EnvironmentType["Development"] = "development";
    EnvironmentType["Production"] = "production";
})(EnvironmentType || (EnvironmentType = {}));
const DevelopmentEnvironmentSlug = "development";
const ProductionEnvironmentSlug = "production";
const DevelopmentEnvironmentName = "Development";
const ProductionEnvironmentName = "Production";
const EnvironmentNames = [
    DevelopmentEnvironmentName,
    ProductionEnvironmentName
];
const isEnvironmentName = (environmentName)=>EnvironmentNames.includes(environmentName);
const EnvironmentNameMSTType = _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.optional(_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.frozen(), DevelopmentEnvironmentName);
const EnvironmentTypeMSTType = _gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.optional(_gadgetinc_mobx_quick_tree__WEBPACK_IMPORTED_MODULE_0__.types.enumeration(Object.values(EnvironmentType)), "development");
const legacyEnvironmentNameMatchesType = (envName, environmentType)=>{
    return envName === DevelopmentEnvironmentName && environmentType === "development" || envName === ProductionEnvironmentName && environmentType === "production";
};
const legacyEnvironmentNameToEnvironmentType = (envName)=>{
    if (envName === DevelopmentEnvironmentName) {
        return "development";
    } else if (envName === ProductionEnvironmentName) {
        return "production";
    } else {
        throw new Error(`Unknown environment name ${envName}`);
    }
};
const environmentTypeToLegacyEnvironmentName = (environmentType)=>{
    if (environmentType === "development") {
        return DevelopmentEnvironmentName;
    } else if (environmentType === "production") {
        return ProductionEnvironmentName;
    } else {
        throw new Error(`Unknown environment type ${environmentType}`);
    }
};
const legacyEnvironmentNameToEnvironmentSlug = (envName)=>{
    if (envName === DevelopmentEnvironmentName) {
        return DevelopmentEnvironmentSlug;
    } else if (envName === ProductionEnvironmentName) {
        return ProductionEnvironmentSlug;
    } else {
        throw new Error(`Unknown environment name ${envName}`);
    }
};
const environmentTypeToNodeEnv = (environmentType)=>{
    switch(environmentType){
        case "test":
            return "test";
        case "development":
            return "development";
        case "production":
            return "production";
    }
};


/***/ }),

/***/ 32249:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   v: () => (/* binding */ playgroundConnectionOptions)
/* harmony export */ });
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88469);
/* harmony import */ var lodash_merge__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_merge__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var state_trees_src_Environment__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96431);


const isAuthenticatedSession = window?.GadgetPlaygroundConfig?.authenticatedSession ?? false;
const baseEndpoint = "/api/graphql";
const playgroundConnectionOptions = (environment)=>{
    const host = window.location.host;
    // authenticated requests use the Session cookie on production domain to make requests and use a header to specify the environment
    // unauthenticated requests must make requests directly to the appropriate environment domain
    let graphqlEndpoint = baseEndpoint;
    let graphqlWSEndpoint;
    if (!isAuthenticatedSession) {
        const domain = host.split(".")[0];
        const environmentAwareHost = host.replace(domain, environment.type === state_trees_src_Environment__WEBPACK_IMPORTED_MODULE_1__/* .EnvironmentType */ .Qj.Production ? domain : `${domain}--${environment.name}`);
        graphqlEndpoint = `https://${environmentAwareHost}${baseEndpoint}`;
        graphqlWSEndpoint = `wss://${environmentAwareHost}${baseEndpoint}/batch`;
    } else {
        graphqlWSEndpoint = `wss://${host}${baseEndpoint}/batch`;
    }
    return {
        environment: environment.type === state_trees_src_Environment__WEBPACK_IMPORTED_MODULE_1__/* .EnvironmentType */ .Qj.Production ? state_trees_src_Environment__WEBPACK_IMPORTED_MODULE_1__/* .ProductionEnvironmentName */ .KG : state_trees_src_Environment__WEBPACK_IMPORTED_MODULE_1__/* .DevelopmentEnvironmentName */ .y2,
        endpoint: graphqlEndpoint,
        websocketsEndpoint: graphqlWSEndpoint,
        authenticationMode: isAuthenticatedSession ? {
            custom: {
                async processFetch (_, init) {
                    init.credentials ??= "include";
                    lodash_merge__WEBPACK_IMPORTED_MODULE_0___default()(init.headers, {
                        "x-gadget-environment": environment.name,
                        "x-gadget-client": "graphql-playground"
                    });
                },
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                async processTransactionConnectionParams () {}
            }
        } : {
            browserSession: true
        }
    };
};


/***/ }),

/***/ 87938:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {


// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/helpers/base-provider.js
var base_provider = __webpack_require__(57040);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/themes/light-theme/create-light-theme.js
var create_light_theme = __webpack_require__(70531);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@0.0.0-experimental-4ead6b530/node_modules/react/index.js
var react = __webpack_require__(30242);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/react-dom/index.js
var react_dom = __webpack_require__(5556);
// EXTERNAL MODULE: ../../node_modules/.pnpm/styletron-react@6.0.2_react@0.0.0-experimental-4ead6b530/node_modules/styletron-react/dist/browser.es5.es.js
var browser_es5_es = __webpack_require__(81262);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@gadgetinc+api-client-core@0.15.21_bufferutil@4.0.6_utf-8-validate@5.0.9/node_modules/@gadgetinc/api-client-core/dist/esm/index.js + 28 modules
var esm = __webpack_require__(30378);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/Column.tsx
var Column = __webpack_require__(63034);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/Row.tsx
var Row = __webpack_require__(71567);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/utils/index.ts
var utils = __webpack_require__(45199);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/GadgetLogo.tsx + 2 modules
var GadgetLogo = __webpack_require__(1462);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@graphiql+toolkit@0.9.1_@types+node@18.15.11_graphql-ws@5.14.1_graphql@16.8.1/node_modules/@graphiql/toolkit/esm/index.js + 14 modules
var toolkit_esm = __webpack_require__(94305);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/styles/styled.js
var styled = __webpack_require__(10334);
// EXTERNAL MODULE: ../../node_modules/.pnpm/graphiql@3.0.5_@codemirror+language@6.8.0_@types+node@18.15.11_@types+react-dom@17.0.5_@types_nus5atvbn5rco7gb4tnxokhzyy/node_modules/graphiql/esm/index.js + 1 modules
var graphiql_esm = __webpack_require__(66290);
// EXTERNAL MODULE: ../../node_modules/.pnpm/mobx-react-lite@3.4.0_mobx@6.5.0_react-dom@0.0.0-experimental-4ead6b530_react@0.0.0-experimental-4ead6b530/node_modules/mobx-react-lite/es/index.js + 16 modules
var es = __webpack_require__(22764);
// EXTERNAL MODULE: ../state-trees/src/Environment.ts
var Environment = __webpack_require__(96431);
;// CONCATENATED MODULE: ./src/lib/playground.css
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: ./src/lib/useEmitReactReady.tsx
var useEmitReactReady = __webpack_require__(58758);
// EXTERNAL MODULE: ./src/components/edit/RoutingContext.tsx
var RoutingContext = __webpack_require__(98221);
// EXTERNAL MODULE: ./src/components/edit/workspace/utils.tsx + 1 modules
var workspace_utils = __webpack_require__(63467);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/button/Button.tsx
var Button = __webpack_require__(45916);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/components/Card.tsx
var Card = __webpack_require__(96363);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/EditTheme.ts
var EditTheme = __webpack_require__(68936);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/AccordionExpandIcon.tsx
var AccordionExpandIcon = __webpack_require__(9179);
// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/CheckmarkIcon.tsx
var CheckmarkIcon = __webpack_require__(45511);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/popover/popover.js + 1 modules
var popover = __webpack_require__(2493);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/popover/constants.js
var constants = __webpack_require__(64165);
// EXTERNAL MODULE: ../../node_modules/.pnpm/github.com+gadget-inc+baseweb@963544a7c8c9d1698a25883109033e9fd1a63684_@types+react@17.0.4_re_r35o3aeqwzojvj3vy4serkz3xm/node_modules/baseui/esm/typography/index.js
var typography = __webpack_require__(61022);
// EXTERNAL MODULE: ./src/components/edit/editor/environment/EnvironmentNameTag.tsx + 1 modules
var EnvironmentNameTag = __webpack_require__(10075);
;// CONCATENATED MODULE: ./src/components/playground/PlaygroundEnvironmentSelector.tsx










const developmentPillBackgroundColor = "#83A1C926";
const productionPillBackgroundColor = "#7D54E833";
const PlaygroundEnvironmentSelector = ({ environment, setEnvironment })=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    const isProdSelected = environment.type == Environment/* EnvironmentType */.Qj.Production;
    const [selectorIsOpen, setSelectorIsOpen] = (0,react.useState)(false);
    const closeMenu = ()=>setSelectorIsOpen(false);
    const envSelectorButtonActivatedStyle = {
        backgroundColor: "hsla(var(--color-neutral), var(--alpha-background-heavy))"
    };
    (0,react.useEffect)(()=>{
        if (isProdSelected) {
            document.body.classList.add("playground-prod");
        } else {
            document.body.classList.remove("playground-prod");
        }
    }, [
        isProdSelected
    ]);
    return /*#__PURE__*/ react.createElement("div", {
        className: css({
            ...(0,utils/* expandBorderRight */.XJ)({
                borderWidth: "1px",
                borderStyle: "solid",
                borderColor: "hsla(var(--color-neutral), var(--alpha-background-heavy))"
            }),
            ...(0,utils/* paddingHorizontal */.WB)(0, $theme.sizing.scale700)
        })
    }, /*#__PURE__*/ react.createElement("span", null, "Environment"), /*#__PURE__*/ react.createElement(popover/* default */.Z, {
        isOpen: selectorIsOpen,
        placement: constants/* PLACEMENT */.r4.bottomLeft,
        content: /*#__PURE__*/ react.createElement(MultiEnvironmentSelector, {
            environment: environment,
            setEnvironment: setEnvironment,
            onClose: closeMenu
        }),
        onClick: ()=>setSelectorIsOpen(!selectorIsOpen),
        onClickOutside: closeMenu,
        onEsc: closeMenu
    }, /*#__PURE__*/ react.createElement(Button/* Button */.zx, {
        kind: "primary",
        endEnhancer: /*#__PURE__*/ react.createElement(AccordionExpandIcon/* AccordionExpandIcon */.K, {
            direction: "down",
            color: "hsl(var(--color-neutral))"
        }),
        "data-testid": "playground-environment-selector",
        overrides: {
            BaseButton: {
                style: ({ $theme })=>({
                        marginLeft: $theme.sizing.scale500,
                        color: isProdSelected ? "hsl(var(--color-prod-neutral))" : "hsl(var(--color-neutral))",
                        backgroundColor: "hsla(var(--color-neutral), var(--alpha-background-light))",
                        borderColor: $theme.colors.black,
                        borderStyle: "solid",
                        borderWidth: "1px",
                        borderRadius: $theme.sizing.scale200,
                        ...selectorIsOpen ? envSelectorButtonActivatedStyle : undefined,
                        [Button/* ButtonHoverSelector */.aH]: envSelectorButtonActivatedStyle,
                        [":active:not(:disabled)"]: envSelectorButtonActivatedStyle
                    })
            }
        }
    }, /*#__PURE__*/ react.createElement("span", {
        className: css({
            fontFamily: EditTheme/* monoFontFamily */.CK,
            backgroundColor: isProdSelected ? productionPillBackgroundColor : developmentPillBackgroundColor,
            paddingLeft: $theme.sizing.scale100,
            paddingRight: $theme.sizing.scale100,
            paddingBottom: $theme.sizing.scale0,
            color: "white",
            borderRadius: $theme.sizing.scale100,
            fontWeight: 500,
            fontSize: $theme.sizing.scale550,
            whiteSpace: "nowrap"
        })
    }, /*#__PURE__*/ react.createElement(EnvironmentNameTag/* EnvironmentNameLabel */.mK, {
        envName: environment.name.toLowerCase(),
        showArrowIcon: !isProdSelected
    })))));
};
const MultiEnvironmentSelector = ({ environment, setEnvironment, onClose })=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    const developmentEnvs = window.GadgetPlaygroundConfig.environments.filter((env)=>env.type === Environment/* EnvironmentType */.Qj.Development);
    const productionEnvs = window.GadgetPlaygroundConfig.environments.filter((env)=>env.type === Environment/* EnvironmentType */.Qj.Production);
    const isProdSelected = environment.type === Environment/* EnvironmentType */.Qj.Production;
    const onEnvSelect = (env)=>()=>{
            setEnvironment(env);
            onClose();
        };
    const envButtonStyle = {
        ":hover": {
            backgroundColor: "hsla(var(--color-neutral), var(--alpha-background-medium))"
        },
        backgroundColor: "transparent",
        borderStyle: "none",
        borderRadius: $theme.sizing.scale200,
        display: "inline-block",
        height: $theme.sizing.scale1000,
        color: $theme.colors.white
    };
    return /*#__PURE__*/ react.createElement(Card/* Card */.Zb, {
        style: {
            textAlign: "center",
            width: "355px",
            backgroundColor: isProdSelected ? "hsl(var(--dark-prod-base))" : "hsl(var(--dark-base))",
            borderColor: $theme.colors.primary600
        },
        tabIndex: -1,
        "data-testid": "playground-environment-list"
    }, /*#__PURE__*/ react.createElement(Card/* CardSection */.uO, {
        $padding: "small",
        $style: {
            borderBottom: `1px solid ${$theme.colors.alpha200}`
        }
    }, productionEnvs.map((env)=>/*#__PURE__*/ react.createElement(Row/* Row */.X, {
            $as: "button",
            onClick: onEnvSelect(env),
            $style: envButtonStyle,
            key: `production-environment-option-${env.slug}`,
            id: `production-environment-option-${env.slug}`
        }, /*#__PURE__*/ react.createElement(EnvironmentNamePillContainer, {
            envName: env.name.toLowerCase(),
            backgroundColor: productionPillBackgroundColor
        }), /*#__PURE__*/ react.createElement(SelectedEnvironmentCheckmark, {
            show: env.name === environment.name
        })))), /*#__PURE__*/ react.createElement(Card/* CardSection */.uO, {
        $padding: "small",
        $style: {
            gap: "0px",
            borderStyle: "solid",
            borderTopWidth: "1px",
            borderBottomWidth: 0,
            borderLeftWidth: 0,
            borderRightWidth: 0,
            borderColor: $theme.colors.primary700
        }
    }, developmentEnvs.length ? /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(typography/* LabelSmall */.S$, {
        $style: {
            color: $theme.colors.primary500,
            textAlign: "left",
            marginTop: $theme.sizing.scale300,
            marginBottom: $theme.sizing.scale300
        }
    }, "Development environments"), developmentEnvs.map((env)=>/*#__PURE__*/ react.createElement(Row/* Row */.X, {
            $as: "button",
            onClick: onEnvSelect(env),
            $style: envButtonStyle,
            key: `development-environment-option-${env.slug}`,
            id: `development-environment-option-${env.slug}`
        }, /*#__PURE__*/ react.createElement(EnvironmentNamePillContainer, {
            envName: env.name.toLowerCase(),
            showArrowIcon: true,
            backgroundColor: developmentPillBackgroundColor
        }), /*#__PURE__*/ react.createElement(SelectedEnvironmentCheckmark, {
            show: env.name === environment.name
        })))) : /*#__PURE__*/ react.createElement(react.Fragment, null, /*#__PURE__*/ react.createElement(typography/* LabelSmall */.S$, {
        $style: {
            color: $theme.colors.contentSecondary
        }
    }, "No environments found"))));
};
const EnvironmentNamePillContainer = ({ showArrowIcon, envName, backgroundColor })=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement("div", {
        style: {
            height: "100%",
            float: "left",
            display: "flex",
            alignItems: "center"
        }
    }, /*#__PURE__*/ react.createElement("span", {
        style: {
            fontFamily: EditTheme/* monoFontFamily */.CK,
            paddingLeft: $theme.sizing.scale100,
            paddingRight: $theme.sizing.scale100,
            paddingBottom: $theme.sizing.scale0,
            borderRadius: $theme.sizing.scale100,
            backgroundColor
        }
    }, /*#__PURE__*/ react.createElement(EnvironmentNameTag/* EnvironmentNameLabel */.mK, {
        envName: envName,
        showArrowIcon: showArrowIcon
    })));
};
const SelectedEnvironmentCheckmark = ({ show })=>{
    return show ? /*#__PURE__*/ react.createElement(Row/* Row */.X, {
        $style: {
            float: "right",
            height: "100%"
        }
    }, /*#__PURE__*/ react.createElement(CheckmarkIcon/* CheckmarkIcon */.K, null)) : /*#__PURE__*/ react.createElement(react.Fragment, null);
};

// EXTERNAL MODULE: ../@gadgetinc/widgets/src/icons/ExternalLinkIcon.tsx
var ExternalLinkIcon = __webpack_require__(12586);
;// CONCATENATED MODULE: ./src/components/playground/PlaygroundHeaderContainer.tsx




const PlaygroundHeaderContainer = (props)=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(Row/* Row */.X, {
        className: `${css({
            height: "48px",
            backgroundColor: "hsl(var(--color-base));"
        })} graphiql-toolbar`
    }, /*#__PURE__*/ react.createElement(Row/* Row */.X, {
        $align: "space-between",
        className: css({
            flexGrow: 1,
            ...(0,utils/* expandBorderBottom */.lK)({
                borderColor: "hsla(var(--color-neutral), var(--alpha-background-heavy))",
                borderStyle: "solid",
                borderWidth: "1px"
            }),
            height: "100%"
        })
    }, /*#__PURE__*/ react.createElement(Row/* Row */.X, {
        className: css({
            ...$theme.typography.LabelSmall,
            color: "hsl(var(--color-neutral))",
            ...(0,utils/* paddingHorizontal */.WB)($theme.sizing.scale500)
        })
    }, props.children), /*#__PURE__*/ react.createElement(Row/* Row */.X, null, /*#__PURE__*/ react.createElement("a", {
        className: css({
            display: "inline-flex",
            ...$theme.typography.LabelXSmall,
            color: "hsl(var(--color-neutral))",
            alignItems: "center",
            textDecoration: "none"
        }),
        href: `${window.GadgetPlaygroundConfig.docsRootURL}/guides?slug=${window.GadgetPlaygroundConfig.applicationSlug}`,
        target: "_blank",
        rel: "noreferrer"
    }, /*#__PURE__*/ react.createElement("span", {
        className: css({
            whiteSpace: "nowrap"
        })
    }, "API Docs"), /*#__PURE__*/ react.createElement(ExternalLinkIcon/* ExternalLinkIcon */.h, {
        className: css({
            ...(0,utils/* marginHorizontal */.oM)($theme.sizing.scale500)
        })
    })))));
};

// EXTERNAL MODULE: ../../node_modules/.pnpm/@graphiql+react@0.19.3_@codemirror+language@6.8.0_@types+node@18.15.11_@types+react-dom@17.0._qpf4xx5bi5ha4kweyd2u56ydmy/node_modules/@graphiql/react/dist/index.mjs + 90 modules
var dist = __webpack_require__(99625);
;// CONCATENATED MODULE: ./src/components/playground/PlaygroundLogsLinkFooter.tsx
/* eslint-disable react/jsx-no-target-blank */ 




const PlaygroundLogsLinkFooter = ()=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    const context = (0,dist/* useEditorContext */._i)({
        nonNull: true
    });
    let logsLink = null;
    if (context.responseEditor) {
        try {
            const value = context.responseEditor.getValue();
            const { extensions } = JSON.parse(value);
            logsLink = extensions?.logs;
        } catch (error) {
        // ignore
        }
    }
    if (!logsLink) {
        return null;
    }
    return /*#__PURE__*/ react.createElement("div", {
        className: css({
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            paddingTop: $theme.sizing.scale100
        })
    }, /*#__PURE__*/ react.createElement("a", {
        href: logsLink,
        target: "_blank",
        className: css({
            ...(0,utils/* paddingUtil */.N1)($theme.sizing.scale200, $theme.sizing.scale400),
            ...(0,utils/* expandMargin */.ds)($theme.sizing.scale100),
            color: "hsl(var(--color-neutral))",
            textDecoration: "none",
            display: "inline-flex",
            flexDirection: "row",
            alignItems: "center",
            gap: $theme.sizing.scale200,
            borderRadius: $theme.borders.radius200,
            [":hover"]: {
                backgroundColor: "hsla(var(--color-neutral), var(--alpha-background-heavy))"
            }
        })
    }, /*#__PURE__*/ react.createElement("span", null, "View logs"), " ", /*#__PURE__*/ react.createElement(ExternalLinkIcon/* ExternalLinkIcon */.h, null)));
};

// EXTERNAL MODULE: ./src/components/playground/utils.ts
var playground_utils = __webpack_require__(32249);
// EXTERNAL MODULE: ../../node_modules/.pnpm/graphql-ws@5.14.1_graphql@16.8.1/node_modules/graphql-ws/lib/client.mjs
var client = __webpack_require__(79178);
;// CONCATENATED MODULE: ./src/components/playground/GraphQLPlayground.tsx



















const GraphiQLComponent = /*#__PURE__*/ (0,react.memo)(({ fetcher, query, variables })=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    return /*#__PURE__*/ react.createElement(graphiql_esm/* GraphiQL */.yB, {
        fetcher: fetcher,
        query: query,
        variables: variables
    }, /*#__PURE__*/ react.createElement(graphiql_esm/* GraphiQL */.yB.Logo, null, /*#__PURE__*/ react.createElement(GadgetLogo/* GadgetLogoMark */.M, {
        className: css({
            height: "auto",
            width: "30px",
            marginTop: $theme.sizing.scale300
        })
    })), /*#__PURE__*/ react.createElement(graphiql_esm/* GraphiQL */.yB.Footer, null, /*#__PURE__*/ react.createElement(PlaygroundLogsLinkFooter, null)));
});
const GraphQLPlayground = (0,es/* observer */.Pi)(()=>{
    const [css, $theme] = (0,styled/* useStyletron */.hQ)();
    (0,useEmitReactReady/* useEmitReactReady */.z)();
    const appName = window?.GadgetPlaygroundConfig?.applicationName ?? "Gadget";
    const router = (0,RoutingContext/* useRouter */.tv)();
    const params = (0,workspace_utils/* getSearchParams */.Qw)(router);
    const query = typeof params.query === "string" ? params.query : undefined;
    const variables = typeof params.variables === "string" ? params.variables : "";
    const environment = (0,react.useMemo)(()=>window.GadgetPlaygroundConfig.environments.find((env)=>env.name === params.environment || env.slug == params.environment) ?? window.GadgetPlaygroundConfig.environments.find((env)=>env.type === Environment/* EnvironmentType */.Qj.Development) ?? {
            name: Environment/* DevelopmentEnvironmentName */.y2,
            type: Environment/* EnvironmentType */.Qj.Development
        }, [
        params.environment
    ]);
    const setEnvironment = (0,react.useCallback)((environment)=>{
        const urlParams = new URLSearchParams(router.location.search);
        urlParams.set("environment", environment.name);
        router.history.replace(`${router.location.pathname}?${urlParams}`);
    }, []);
    const fetcher = (0,react.useMemo)(()=>{
        const options = (0,playground_utils/* playgroundConnectionOptions */.v)(environment);
        const connection = new esm/* GadgetConnection */.Qe(options);
        return (0,toolkit_esm/* createGraphiQLFetcher */.nq)({
            url: options.endpoint,
            wsClient: options.websocketsEndpoint ? (0,client/* createClient */.eI)({
                url: options.websocketsEndpoint,
                connectionParams: {
                    environment: environment.name
                }
            }) : undefined,
            fetch: connection.fetch
        });
    }, [
        environment
    ]);
    return /*#__PURE__*/ react.createElement(Column/* Column */.s, {
        className: css({
            height: "100vh"
        })
    }, /*#__PURE__*/ react.createElement(PlaygroundHeaderContainer, null, /*#__PURE__*/ react.createElement(PlaygroundEnvironmentSelector, {
        environment: environment,
        setEnvironment: setEnvironment
    }), /*#__PURE__*/ react.createElement(Row/* Row */.X, {
        className: css({
            ...$theme.typography.LabelSmall,
            color: "hsl(var(--color-neutral))",
            ...(0,utils/* marginHorizontal */.oM)($theme.sizing.scale700)
        })
    }, appName)), /*#__PURE__*/ react.createElement(Row/* Row */.X, {
        className: css({
            flexGrow: 1,
            overflow: "hidden"
        })
    }, /*#__PURE__*/ react.createElement(GraphiQLComponent, {
        fetcher: fetcher,
        query: query,
        variables: variables
    })));
});

// EXTERNAL MODULE: ./src/lib/flags.ts
var flags = __webpack_require__(20280);
// EXTERNAL MODULE: ./src/lib/styletronEngine.tsx
var styletronEngine = __webpack_require__(40237);
;// CONCATENATED MODULE: ./src/graphql-playground.tsx








react_dom.unstable_createRoot((0,utils/* assert */.hu)(document.getElementById("root"))).render(/*#__PURE__*/ react.createElement(react.StrictMode, null, /*#__PURE__*/ react.createElement(flags/* FlagsProvider */.Q_, {
    flags: flags/* CurrentFlags */.p
}, /*#__PURE__*/ react.createElement(base_provider/* default */.Z, {
    theme: (0,create_light_theme/* default */.Z)({})
}, /*#__PURE__*/ react.createElement(browser_es5_es/* Provider */.zt, {
    value: styletronEngine/* styletronEngine */.F,
    debug: styletronEngine/* styletronDebug */.A
}, /*#__PURE__*/ react.createElement(GraphQLPlayground, null))))));


/***/ }),

/***/ 58758:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   z: () => (/* binding */ useEmitReactReady)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30242);

/**
 * Emit an event the first time we're rendered for anyone listening
 * Used by Cypress to wait for the react app to hydrate before running tests
 */ const useEmitReactReady = ()=>{
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (typeof window != "undefined") {
            // fire an event on the window when the layout mounts for cypress to know the app has booted
            window.dispatchEvent(new Event("gadget:react:ready"));
            window.gadgetReactReady = true;
        }
    }, []);
};


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [1504,284,5743,5670,5757,990,3349,2734,2228,2454], () => (__webpack_exec__(87938)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);